import { render, staticRenderFns } from "./TradeRecord.vue?vue&type=template&id=bcd3811a&"
import script from "./TradeRecord.vue?vue&type=script&lang=js&"
export * from "./TradeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports